import React from "react";
import harryAndSidImage from "../assets/images/Nastalgia/harryandsid.jpg"; // Import the image
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUtensils,
  faCarrot,
  faAward,
} from "@fortawesome/free-solid-svg-icons";
import "./AboutPage.css";

const AboutPage = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1 className="force-revue">Our Story</h1>
          <p className="subtitle">Serving Metro Detroit since 1973</p>
        </div>
      </section>

      {/* Sid and Harry Story Section - MOVED HERE */}
      <section className="sid-harry-section"> {/* Added a new section wrapper */}
        <div className="container">
          <div className="sid-harry-story">
            <img
              src={harryAndSidImage} // Use the imported image variable
              alt="Sid and Harry Neuman of Star Deli"
              className="sid-harry-photo"
            />
            <div className="sid-harry-text">
              <p>
                Sid Neuman and his beloved wife, the late Rose Neuman, bought Star Deli in 1973.
                A few years later, their son Harry joined the team and since then,
                Sid and Harry have worked to turn this reputable institution into the landmark it is today.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Moved Awards Section Up */}
      <section className="awards">
        <div className="container">
          <h2 className="force-revue">Recognition & Awards</h2>
          {/* New grid container for awards */}
          <div className="awards-content-grid">
            <div className="hall-of-fame award-item">
              <div className="coin-container" aria-label="Vienna Beef Delicatessen Hall of Fame 3D Coin Award">
                <div className="coin-float-wrapper">
                  <div className="coin">
                    {/* 3D Edge layers to build realistic metallic depth */}
                    <div className="coin-edge-layer" style={{ transform: "translateZ(-5px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(-4px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(-3px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(-2px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(-1px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(0px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(1px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(2px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(3px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(4px)" }}></div>
                    <div className="coin-edge-layer" style={{ transform: "translateZ(5px)" }}></div>

                    {/* Front Face: The original badge logo */}
                    <div className="coin-face coin-front">
                      <div className="coin-inner-rim">
                        <img
                          src="/images/badges/vienna-beef-hall-of-fame.png"
                          alt="Vienna Beef Delicatessen Hall of Fame Logo"
                          className="hall-of-fame-badge"
                        />
                      </div>
                    </div>

                    {/* Back Face: Elegant gold seal engraving */}
                    <div className="coin-face coin-back">
                      <div className="coin-inner-rim">
                        <div className="coin-back-content">
                          <FontAwesomeIcon icon={faAward} className="coin-back-icon" />
                          <div className="coin-back-title">VIENNA BEEF</div>
                          <div className="coin-back-subtitle">HALL OF FAME</div>
                          <div className="coin-back-subsubtitle">STAR DELI</div>
                          <div className="coin-back-stars">★ ★ ★ ★ ★</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="hall-of-fame-text">
                <h3>Vienna Beef Hall of Fame</h3>
                <p>
                  Proudly inducted into the Vienna Beef Delicatessen Hall of Fame
                  for our commitment to quality and tradition.
                </p>
              </div>
            </div>

            <div className="other-awards award-item"> {/* Added .award-item class */}
              <h3>Other Recognitions</h3>
              <ul>
                <li>Hour Detroit Magazine's "Best Deli" multiple years</li>
                <li>Metro Detroit A-List "Best Sandwich"</li>
                <li>Featured in Midwest Living Magazine</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-history">
        <div className="container">
          <div className="history-content">
            <h2 className="force-revue">A Southfield Tradition</h2>
            <p>
              Since 1973, Star Deli has been serving up the most authentic
              Jewish deli experience in Metro Detroit. Family owned and operated
              for over 50 years, we take pride in our time-honored recipes and
              commitment to quality.
            </p>
            <p>
              From our famous corned beef sandwiches to our homemade matzo ball
              soup, every item on our menu is prepared with care and the finest
              ingredients.
            </p>

            <div className="about-highlights">
              <div className="highlight">
                <FontAwesomeIcon icon={faAward} />
                <span>Voted Best Deli in Metro Detroit</span>
              </div>
              <div className="highlight">
                <FontAwesomeIcon icon={faUtensils} />
                <span>Family Recipes Since 1973</span>
              </div>
              <div className="highlight">
                <FontAwesomeIcon icon={faCarrot} />
                <span>Fresh, Premium Ingredients</span>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Awards section was moved up */}
    </div>
  );
};

export default AboutPage;
